export const bookingPresenceFilterValues = {
  PRESENT: 'confirmedAt IS NOT NULL',
  ABSENT: 'confirmedAt IS NULL',
} as const;

export type BookingPresenceFilterValue =
  (typeof bookingPresenceFilterValues)[keyof typeof bookingPresenceFilterValues];
